import { useIsAuthenticated } from 'mf_core/auth';
import React, { useEffect, useState } from 'react';
import { StickyButton } from '@im/ui-lib/StickyButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CopyRightTO } from '@im/ui-lib/types';

type Props = {
  data?: CopyRightTO;
};

export function IngramBecomeReseller(props: Props) {
  const { data } = props;
  const [ready, setReady] = useState(false);
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    //Adding artificial delay to wait for useIsAuthenticated() state change
    const timer = setTimeout(() => setReady(true), 3000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const isMobile = useMediaQuery('(min-width: 769px)');

  return isAuthenticated ? (
    <></>
  ) : (
    <>
      {ready && isMobile && data?.onClick && (
        <StickyButton link={data} onClick={data.onClick} />
      )}
    </>
  );
}
